const dashboardReducer = (
  state = {
    graphCategory: 'Voltage',
    timerange: '1h'
  },
  action
) => {
  switch (action.type) {
    case 'SET_CLICKED_CABINET':
      return { ...state, cabinetId: action.payload };
    case 'SET_GRAPH_CATEGORY':
      return { ...state, graphCategory: action.payload };
    case 'SET_GRAPHED_COMPONENT_ID':
      return { ...state, graphedComponentId: action.payload };
    case 'SET_CLICKED_SYSTEM_ID':
      return { ...state, activeSystemId: action.payload };
    case 'SET_TIMERANGE':
      return { ...state, timerange: action.payload };
    case 'SET_ACTIVE_SYSTEM':
      return { ...state, activeSystem: action.payload };
    default:
      return state;
  }
};

export default dashboardReducer;
